import { useState } from "react"
import { isIOS } from 'utils/getDevice'
import { steps } from "./data"

const useAuthorizeSMSStep = ({ fireboltStep }) => {
  
  const [stepId, setStepId] = useState(0)
  const [isChecked, setIsChecked] = useState(false)
  const [isVisible, setIsVisible] = useState(true)
  
  const tutorialStart = 1
  const isFirstStep = stepId === 0
  const isLastStep = stepId === 7
  const isTutorial = stepId !== 0 && stepId !==7
  const isDisabled = stepId === 7 && !isChecked

  const defaultText = (isChecked || !isFirstStep) ? 'Continuar' : 'Saiba como autorizar o SMS'
  const tutorialBtnText = 'Próximo passo'
  const buttonText = isTutorial ? tutorialBtnText : defaultText


  const stepData = steps[stepId]

  const goNext = () => {
    setStepId(stepId + 1)
  }

  const gotoTutorial = () => {
    setStepId(tutorialStart)
  }
  
  const handleChange = () => {
    isChecked === false ? setIsChecked(true) : setIsChecked(false)
  }

  const closeModal = () => {
    setIsVisible(false)
  }
  
  const buttonAction = () => {
    if (isChecked) {
      fireboltStep.goNextStep()
    }
    goNext()
  }

  const storeLink = isIOS()
  ? 'https://apps.apple.com/br/app/banco-do-brasil/id330984271'
  : 'https://play.google.com/store/apps/details?id=br.com.bb.android'



  return {
    isVisible,
    stepData,
    gotoTutorial,
    handleChange,
    closeModal,
    buttonAction,
    storeLink,
    isLastStep,
    isTutorial,
    isDisabled,
    buttonText
  }

}

export default useAuthorizeSMSStep